import React, { useState } from "react";
import ProsureLogo from "../../assets/svg/ProSure.svg";
import BoxTop from "../../assets/svg/box-top.svg";
import BoxBottom from "../../assets/svg/box-bottom.svg";
import CheckBlue from "../../assets/svg/check-blue.svg";
import CheckBig from "../../assets/svg/check-big.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./style.scss";
import PrimaryButton from "../../components/Button/PrimaryButton";
import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import styled from "@emotion/styled";
import { resetPrice, updatePrice } from "../../store/reducers/home";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { resetDetail } from "../../store/reducers/prosure";
import { resetLogin } from "../../store/reducers/authentication";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 7,
  width: 34,
  height: 34,
  // boxShadow: 'inset 0 0 0 1px #CAD3E5, inset 0 1px 0 #CAD3E5',
  border: "1.69px solid #CAD3E5",
  backgroundColor: "#FFFFFF",
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5",
  },
  "@media (max-width: 1000px)": {
    width: 20,
    height: 20,
    borderRadius: 4,
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#1E56FF",
  // backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  "&::before": {
    display: "block",
    width: 30,
    height: 30,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
    "@media (max-width: 1000px)": {
      width: 16,
      height: 16,
    },
  },
  "input:hover ~ &": {
    backgroundColor: "#1E56FF",
  },
});

function BpCheckbox(props: CheckboxProps) {
  return (
    <Checkbox
      sx={{ "&:hover": { bgcolor: "transparent" } }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
}
const ProsureForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authKey: any = useSelector((state: any) => state);
  const [optionOne, setOptionOne] = useState(true);
  const [optionTwo, setOptionTwo] = useState(false);
  // Function to calculate price based on selected options
  const calculatePrice = () => {
    if (optionOne && optionTwo) return "299.00";
    if (optionOne) return "253";
    if (optionTwo) return "35.40";
    return "0";
  };

  const handleBuy = () => {
    if(authKey?.authentication?.login?.agent_id){
      const price = 299
      // calculatePrice();
      dispatch(updatePrice(price));
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
      window.scrollTo(0, 0);
    }else{
      dispatch(resetDetail({}));
      dispatch(resetPrice(0));
      dispatch(resetLogin())
      localStorage.clear()
      navigate(ROUTE_PATH.UN_AUTH);
    }
  };

  return (
    <div>
      <div className="pro-box mb-[38px] lg:mb-[0px] lg:ml-[10px] w-[100%] py-[16px] px-[12px] lg:p-[45px] xl:p-[60px] border-[1px] border-border-color-2 rounded-tl-[16px] rounded-tr-[16px] rounded-bl-[16px] rounded-br-[16px] lg:rounded-tr-[0px] lg:rounded-tr-[0px] lg:rounded-tl-[35px] lg:rounded-bl-[35px] bg-bg-color-2 flex flex-col items-center justify-center shadow-custom-light">
        <img src={BoxTop} alt="BoxTop" className="left-img" />
        <img src={BoxBottom} alt="BoxBottom" className="right-img" />
        <img src={ProsureLogo} alt="ProsureLogo" className="block lg:hidden" />
        <div className="hidden lg:block lg:text-[64px] lg:leading-[66px] text-text-color-5 font-extrabold text-[24px] leading-[24px] text-center">
          ProSure
        </div>
        <div className="lg:pt-[54px] pt-[18px] flex items-center lg:justify-around justify-around w-[100%]">
          <div className="flex items-center text-[10px] leading-[14px] lg:text-[18px] lg:leading-[24px] text-text-color-5 font-extrabold z-10">
            <img
              src={CheckBlue}
              alt="CheckBlue"
              className="mr-[5px] lg:mr-[8px] xl:hidden block"
            />
            <img
              src={CheckBig}
              alt="CheckBlue"
              className="mr-[5px] lg:mr-[11px] hidden xl:block"
            />
            Wellness
          </div>
          {/* <div className="flex items-center text-[10px] leading-[14px] lg:text-[18px] lg:leading-[24px] text-text-color-5 font-extrabold z-10">
            <img
              src={CheckBlue}
              alt="CheckBlue"
              className="mr-[5px] lg:mr-[8px] xl:hidden block"
            />
            <img
              src={CheckBig}
              alt="CheckBlue"
              className="mr-[5px] lg:mr-[11px] hidden xl:block"
            />
            CoverSure Platform
          </div> */}
          {/* <div className="flex items-center text-[10px] leading-[14px] lg:text-[18px] lg:leading-[24px] text-text-color-5 font-extrabold z-10">
            <img
              src={CheckBlue}
              alt="CheckBlue"
              className="mr-[5px] lg:mr-[8px] xl:hidden block"
            />
            <img
              src={CheckBig}
              alt="CheckBlue"
              className="mr-[5px] lg:mr-[11px] hidden xl:block"
            />
            Hospicash
          </div> */}
        </div>
        <div className="w-[100%] bg-white p-[12px] lg:p-[20px] z-10 rounded-[12px] lg:rounded-[20px] my-[14px] lg:my-[23px] pro-select shadow-custom-light">
          <div className="w-[100%] flex item-center py-[16px]">
            <div className="w-3/4">
              {/* <FormControlLabel
                control={
                  <BpCheckbox
                    checked={optionOne}
                    onChange={(e: any) => setOptionOne(e.target.checked)}
                    disabled
                    sx={{
                      color: "#CAD3E5",
                      "&.Mui-checked": {
                        color: "#1E56FF",
                      },
                    }}
                  />
                }
                label="Insurance management & wellness services"
                className="checkbox-style"
              /> */}
              <div className="detail-text">
                {/* Wellness benefits & CoverSure platform */}
                Wellness services
              </div>
            </div>
            <div className="w-1/4 text-[12px] leading-[18px] lg:text-[20px] lg:leading-[30px] font-black text-text-color-6 flex items-center justify-end">
              ₹ 253
            </div>
          </div>
          <div className="w-[100%] flex item-center py-[16px]">
            <div className="w-3/4">
              <div className="detail-text">GST</div>
            </div>
            <div className="w-1/4 text-[12px] leading-[18px] lg:text-[20px] lg:leading-[30px] font-black text-text-color-6 flex items-center justify-end">
              ₹ 46
            </div>
          </div>
          {/* <div className="w-[100%] flex item-center py-[16px]">
            <div className="w-3/4">
              <FormControlLabel
                control={
                  <BpCheckbox
                    checked={optionTwo}
                    onChange={(e: any) => setOptionTwo(e.target.checked)}
                    sx={{
                      color: "#CAD3E5",
                      "&.Mui-checked": {
                        color: "#1E56FF",
                      },
                    }}
                  />
                }
                label="Hospicash Insurance"
                className="checkbox-style"
              />
            </div>
            <div className="w-1/4 text-[12px] leading-[18px] lg:text-[20px] lg:leading-[30px] font-black text-text-color-6 flex items-center">
              ₹ 35.40
            </div>
          </div> */}
          <div className="w-[100%] border-b-[1px] border-text-color-4"></div>
          <div className="w-[100%] flex item-center pt-[16px]">
            <div className="w-3/4 text-[12px] leading-[18px] lg:text-[20px] lg:leading-[30px] text-text-color-3 flex items-center">
              Total
            </div>
            <div className="w-1/4 text-[12px] leading-[18px] lg:text-[20px] lg:leading-[30px] font-black text-text-color-6 flex items-center justify-end">
              ₹ 299
              {/* {calculatePrice()} */}
            </div>
          </div>
        </div>
        <div className="w-[100%]">
          <PrimaryButton
            onClick={handleBuy}
            // disabled={!optionTwo}
            label={
              <div className="flex items-center justify-between w-[100%] font-black">
                <div className="text-[14px] leading-[18px] lg:text-[24px] lg:leading-[30px] ">
                  ₹ 299
                  {/* {calculatePrice()} */}
                </div>
                <div className="flex items-center justify-between text-[14px] leading-[18px] lg:text-[24px] lg:leading-[30px]">
                  Buy now <ArrowForwardIcon />
                </div>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ProsureForm;
